import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import {toast} from "react-toastify";

const AttendanceRequestList = ({
  fetchAttendanceRequests,
  getAttendanceRequests,
  valetIncentiveFilter,
  valetAttendanceRequest
}) => {
  const headers = [
    "Attendance Id",
    "Project Id",
    "Valet Name",
    "Site Name",
    "Regularization Date",
    "Punch-In Time",
    "Current Attendance Type",
    "Requested Attendance Type",
    "Reject",
    "Approve"
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();
  const [ActionModal, setActionModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const headerBtns = () => {
    // return (
    //   <Fragment>
    //     <Button
    //       onClick={filterToggle}
    //       className="filter-hamburger btn btn-transparent"
    //     >
    //       <img src={Images?.Filter} alt=""></img>
    //       {localization.showFilters}
    //     </Button>
    //   </Fragment>
    // );
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setIsRoleId(window.localStorage.getItem("fusion-role"));
      await fetchAttendanceRequests(null, 1);
      setIsLoading(false);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await fetchAttendanceRequests(null, val.selected + 1);
    setIsLoading(false);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("all_valet_list_filter", JSON.stringify(filterData));
    setListData([]);
    setIsLoading(true);
    setFilterData(filterData);
    console.log("Filter Data: " + JSON.stringify(filterData));
    await fetchAttendanceRequests(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const DAYS_MAP = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  };

  const mapDays = (daysOff) => {
    if (!daysOff) return "";
    return daysOff
      .toString()
      .split("")
      .map((day) => DAYS_MAP[day] || "")
      .filter((day) => day !== "")
      .join(", ");
  };

  const [formData, setFormData] = useState({
    day_type: "",
    remarks: "",
    date: ""
  });

  useEffect(() => {
    const tableData = [
      "attendance_id",
      "project_id",
      "valet_name",
      "project_name",
      "request_date",
      "start_time",
      "current_status",
      "attendance_type",
      "reject_attendance",
      "approve_attendance"
    ];

    if (getAttendanceRequests && getAttendanceRequests.resultSets) {
      const data = getAttendanceRequests.resultSets.map((element) =>
        Object.assign(
          {
          },
          ...tableData.map((key) => ({
            [key]:
              key === "days_off"
                ? mapDays(element[key])
                : key === "is_primary_role"
                ? element["is_primary_role"] === true
                  ? "True"
                  : "False"
                : element[key],
          })),
          {}
        )
      );

      if (data.length > 0) {
        setListData(data);
      } else {
        setListData([]);
      }

      setPageCount(
        Math.ceil(getAttendanceRequests.total / getAttendanceRequests.per_page)
      );
    }
  }, [getAttendanceRequests]);

  const handleActionModalHide = () => {
    setActionModal(false);
    setFormData((prev) => ({
      ...prev,
      remarks: "",
      day_type: "",
      date: ""
    }));
  };

  const handleConfirmModalHide = () => {
    setConfirmModal(false);
    setFormData((prev) => ({
      ...prev,
      remarks: "",
      day_type: "",
    }));
  };

  const handleConfirmModalClose = () => {
    setActionModal(false);
    setConfirmModal(false);
    setFormData((prev) => ({
      ...prev,
      remarks: "",
      day_type: "",
    }));
  };

  const handleAttendanceAction = (attendance_id, project_id, status, regularization_date) => {
    console.log(attendance_id)
    console.log(project_id)
    console.log(status)
    console.log(regularization_date)
    setSelectedRequestId(attendance_id);
    setSelectedStatus(status);
    setSelectedProjectId(project_id);
    setSelectedDate(regularization_date);
    if (status === 'Rejected') {
      setConfirmModal(true);
    } else {
      setActionModal(true);
    }
  };

  const handleSubmit = async () => {

    let requestParams = {
      status: selectedStatus,
      project_id: selectedProjectId,
      attendance_request_id: selectedRequestId,
      remarks : formData?.remarks,
      date: selectedDate
    };

    if (selectedStatus === 'Approved') {
      requestParams.attendance_type = formData?.day_type;
    }

    try {
      const response = await valetAttendanceRequest(requestParams);

      if (response?.response?.status) {
        if(selectedStatus=="Approved"){
          toast.success('Approved Successfully');
        }
        else{
          toast.success('Rejected Successfully');
        }
        setSelectedStatus(null);
        setSelectedRequestId(null);
        setSelectedProjectId(null);
        setSelectedDate(null);
        handleConfirmModalClose();
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        setSelectedStatus(null);
        setSelectedRequestId(null);
        setSelectedProjectId(null);
        setSelectedDate(null);
        toast.error(response?.message);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    } catch (error) {
      setSelectedStatus(null);
      setSelectedRequestId(null);
      setSelectedProjectId(null);
      setSelectedDate(null);
      console.error("API Error:", error);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }

  };

  return (
    <Layout
      title={"Attendance Request List"}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={getAttendanceRequests?.from}
        onPageChange={onPageChange}
        // serialNo = {false}
        handleAttendanceAction={(attendance_id, project_id, status, regularization_date) => handleAttendanceAction(attendance_id, project_id, status, regularization_date)}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        allValetListFilter
      />

      <ModalPop
        title={"Approve Request"}
        show={ActionModal}
        handleModalHide={handleActionModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h4>{"Please select the day type"}</h4>
          <div className="col-md-12">
            <DropDownInput
              data={[
                { id: "RegularisationHalfDay", name: "Half Day" },
                { id: "RegularisationFullDay", name: "Full Day" },
                { id: "Overtime", name: "Overtime" },
              ]}
              label={"Day Type"}
              required
              getIdValue={(val) => {
                setFormData({ ...formData, day_type: val.id });
              }}
              isStarRequired={true}
            />
          </div>
          <div className="col-md-12">
            <TextAreaInput
              type="text"
              rows={4}
              label={"Remarks"}
              value={formData?.remarks}
              inputValue={formData?.remarks}
              isStarRequired={true}
              errorMsg={localization.isRequired}
              handleChange={(e) =>
                setFormData({ ...formData, remarks: e.target.value })
              }
            />
          </div>
          <div className="col-md-4 d-flex">
            <Button
              className="btn btn-success"
              onClick={() => {
                setActionModal(false);
                setConfirmModal(true);
              }}
            >
              Approve
            </Button>
          </div>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.conf}
        show={confirmModal}
        handleModalHide={handleConfirmModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          {selectedStatus == 'Rejected' ?
          <h4>{`Are you sure you want reject the request?`}</h4> :
          <h4>{`Are you sure you want to mark ` + formData?.day_type + `?`}</h4>
          }
          <div className="col-md-12">
            <TextAreaInput
              type="text"
              rows={4}
              label={"Remarks"}
              inputValue={formData?.remarks}
              isDisabled
              disabled={selectedStatus=='Approved'}
              isStarRequired={true}
              handleChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
            />
          </div>
          <div className="col-md-6 d-flex mt-5">
            <div className="col-md-3">
              <Button
                className="btn btn-danger"
                onClick={handleConfirmModalClose}
              >
                No
              </Button>
            </div>
            <div className="col-md-3">
              <Button
                className="btn btn-success"
                onClick={handleSubmit}
              >
                Yes
              </Button>
            </div>
          </div>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default AttendanceRequestList;
